/**
 * Fetches a page of results of the authenticated user's recent tickets in a
 * particular course
 *
 * NOTE: This is a redux action, so it must be dispatched
 */

import accountTicketIndexRoute from 'api/routes/tickets/account-ticket-index';
import loadRecords from 'actions/load-records';

export default function fetchTicketHistory(courseId, page = 0, size = 10) {
  return (dispatch) => {
    return accountTicketIndexRoute(courseId, page, size).then(
      ({ status, headers, data }) => {
        if (status === 200) {
          dispatch(loadRecords(data));
        }
        return { status, headers, data };
      }
    );
  };
}
